import { ClickEvent } from "@mcleod/components";
import { McLeodClassicIntegration } from "@mcleod/core";
import { AutogenLayoutOrderHistType } from "./autogen/AutogenLayoutOrderHistType";

export class OrderHistType extends AutogenLayoutOrderHistType {
    buttonClassicModeOnClick(event: ClickEvent) {
        McLeodClassicIntegration.openClassicScreen(this.sourceOrderHistType.activeRow?.get("screen_class_name"), "<ext> sort id");
    }
}
